//@flow
import * as React from 'react';
import { themr } from 'react-css-themr';
import { locationCardFactory } from 'common/components/core/card/LocationCard';
import theme from './GroupedLocationCard.scss';
import StringUtils from 'common/utils/StringUtils';
import BulkLocationCardContainer from 'common/entity/locationMaster/BulkLocationCardContainer';

const ExpandedGroup = ({
    locationEntity: locationGroup,
    expandedLocationId,
    selectedLocationId,
    handleSingleVerify,
    handleSingleCardClick,
    handleAddressChange,
    handleResetSingleLocation,
    handleLatLngClick,
    getRadiusAndCenter
}) => {
    return (
        <div>
            {locationGroup.locations.map(location => {
                return (
                    <BulkLocationCardContainer
                        key={location.id}
                        locationEntity={location}
                        onVerify={handleSingleVerify}
                        onCardClick={handleSingleCardClick}
                        theme={theme}
                        className={theme.bulkLocationCard}
                        index={location.index}
                        isVerified={location.verified}
                        shouldShowOriginalColor
                        isExpanded={expandedLocationId === location.id}
                        isSelected={selectedLocationId === location.id}
                        onAddressChange={handleAddressChange}
                        onReset={handleResetSingleLocation}
                        isResetEnabled={!location.isOriginal}
                        onLatLngClick={handleLatLngClick}
                        getRadiusAndCenter={getRadiusAndCenter}
                        isEditable
                    />
                );
            })}
        </div>
    );
};

const GroupedLocationCardComponent = locationCardFactory({
    CollapseComponent: ExpandedGroup
});

class GroupedLocationCard extends React.PureComponent {
    render() {
        const {
            groupedLocation,
            handleVerify,
            handleCardClick,
            handleGroupVerify,
            handleGroupCardClick,
            handleAddressChange,
            index,
            isExpanded,
            style,
            theme,
            expandedLocationId,
            selectedLocationId,
            isEditInProgress,
            isVerifyInProgress,
            handleResetSingleLocation,
            handleResetGroupLocations,
            handleLatLngClick,
            getRadiusAndCenter
        } = this.props;
        const { locations } = groupedLocation;
        const subtitle = StringUtils.pluralize('location', locations.size);

        return (
            <GroupedLocationCardComponent
                label={groupedLocation.groupId}
                subText={subtitle}
                onVerify={handleGroupVerify}
                className={theme.groupedLocationCard}
                isVerified={groupedLocation.isGroupVerified()}
                handleSingleVerify={handleVerify}
                handleSingleCardClick={handleCardClick}
                onCardClick={handleGroupCardClick}
                index={index}
                theme={theme}
                style={style}
                showLeftText={false}
                locationEntity={groupedLocation}
                isExpanded={isExpanded}
                isEditInProgress={isEditInProgress}
                isVerifyInProgress={isVerifyInProgress}
                expandedLocationId={expandedLocationId}
                selectedLocationId={selectedLocationId}
                handleAddressChange={handleAddressChange}
                handleResetSingleLocation={handleResetSingleLocation}
                onReset={handleResetGroupLocations}
                isResetEnabled={!groupedLocation.isGroupOriginal()}
                handleLatLngClick={handleLatLngClick}
                getRadiusAndCenter={getRadiusAndCenter}
                isEditable
            />
        );
    }
}

export default themr('GroupedLocationCard', theme)(GroupedLocationCard);
